import { MainTitle } from 'common/text';
import BackButton from 'common/buttons/back';
import { Content } from 'common/containers';
import EditOrderStatusForm from 'components/forms/orderStatus/edit';
import useFetchData from 'hooks/useFetchData';
import Skeleton from 'common/skeleton';
import { useParams } from 'react-router-dom';
const OrderStatusEdit = () => {
	const { id } = useParams<{ id: string }>();
	const { response, isLoading } = useFetchData(`order-status/${id}`);
	return (
		<>
			<MainTitle>
				<h1>Editar estatus de orden</h1>
				<BackButton />
			</MainTitle>
			<Content>
				{isLoading && <Skeleton count={10} />}
				{!isLoading && (
					<EditOrderStatusForm
						data={response}
						id={id}
					/>
				)}
			</Content>
		</>
	);
};
export default OrderStatusEdit;
